import styled from 'styled-components';

export const SkeletonWhiteWrap = styled.div({
  backgroundColor: 'white',
});
